function TrackUTMParams(): void {
    const isUTMParamExists = (): boolean => {
        const urlParams = new URLSearchParams(window.location.search);
        const paramsKeys = Array.from(urlParams.keys());

        return paramsKeys.some((param: string) => {
            return param.includes('utm_');
        });
    };

    const saveToSessionStorage = (): void => {
        const urlParams = new URLSearchParams(window.location.search);
        const paramsKeys = Array.from(urlParams.keys());

        const utmParams = paramsKeys.reduce((acc: { [key: string]: string | null }, param: string) => {
            if (param.includes('utm_')) {
                acc[param] = urlParams.get(param);
            }

            return acc;
        }, {});

        sessionStorage.setItem('utmParams', JSON.stringify(utmParams));
    };

    if (isUTMParamExists()) {
        saveToSessionStorage();
    }
}

document.addEventListener('DOMContentLoaded', () => {
    // initiate UTM tracker
    TrackUTMParams();
});
